import { HeadingBanner, Paragraph } from "../basic/title";

export default function SingleBlog({ onedata }) {
    if (!onedata) {
        return (
            <div className="text-center py-10 text-gray-500">
                No blog data available.
            </div>
        );
    }

    const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL || "http://localhost:8000/storage/";

    const fullImage = onedata.image?.startsWith("http")
        ? onedata.image
        : BASE_IMAGE_URL + onedata.image;

    const safeDate = onedata.date || "January 01, 2022";
    const dateParts = safeDate.split(" ");

    const month = dateParts[0]?.slice(0, 3) || "Jan";
    const day = dateParts[1]?.replace(",", "") || "01";

    return (
        <>
            {/* 🖼️ Full Blog Image Card */}
            <div className="relative w-full max-w-full h-[400px] rounded-lg overflow-hidden shadow-lg">
                <img
                    src={fullImage}
                    alt={onedata.title}
                    className="w-full h-full object-cover"
                />

                {/* 📅 Date Badge */}
                <div className="absolute top-4 left-4 bg-[#036642] text-white px-4 py-3 rounded-r-lg border-l-4 border-[#00A762] shadow">
                    <h2 className="text-white font-dm text-lg capitalize font-medium">
                        {month}
                    </h2>
                    <Paragraph title={day} textAlign="left" color="white" />
                </div>
            </div>

            {/* 📝 Blog Content */}
            <div className="my-6">
                <h1 className="font-dm text-4xl mb-2 capitalize font-medium md:text-left text-center text-[#072320]">
                    {onedata.title}
                </h1>
                <Paragraph title={onedata.description} textAlign="left" />
            </div>
        </>
    );
}
